import React, { useRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { borderRadius, white, spacing } from '@propellerads/stylevariables';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        &::before {\n          border-top: 6px solid transparent;\n          border-bottom: 6px solid transparent;\n          left: -8px;\n          top: 50%;\n          margin-top: -5px;\n        }\n        \n        &::after {\n          border-right-color: hsl(0, 0%, 13%);\n          border-right-style: solid;\n          border-right-width: 6px;\n          border-top: 5px solid transparent;\n          border-bottom: 5px solid transparent;\n          left: -6px;\n          top: 50%;\n          margin-top: -4px;\n        }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        &::before {\n          border-top: 6px solid transparent;\n          border-bottom: 6px solid transparent;\n          right: -8px;\n          top: 50%;\n          margin-top: -5px;\n        }\n    \n        &::after {\n          border-left-color: hsl(0, 0%, 13%);\n          border-left-style: solid;\n          border-left-width: 6px;\n          border-top: 5px solid transparent;\n          border-bottom: 5px solid transparent;\n          right: -6px;\n          top: 50%;\n          margin-top: -4px;\n        }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        &::before {\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          top: -8px;\n          left: 50%;\n          margin-left: -10px;\n        }\n    \n        &::after {\n          border-bottom-color: hsl(0, 0%, 13%);\n          border-bottom-style: solid;\n          border-bottom-width: 6px;\n          border-left: 8px solid transparent;\n          border-right: 8px solid transparent;\n          top: -6px;\n          left: 50%;\n          margin-left: -8px;\n        }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        &::before {\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          bottom: -8px;\n          left: 50%;\n          margin-left: -10px;\n        }\n    \n        &::after {\n          border-top-color: hsl(0, 0%, 13%);\n          border-top-style: solid;\n          border-top-width: 6px;\n          border-left: 8px solid transparent;\n          border-right: 8px solid transparent;\n          bottom: -6px;\n          left: 50%;\n          margin-left: -8px;\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      background-color: hsl(0, 0%, 13%);\n      border-radius: ", "px;\n      border-collapse: collapse;\n      box-sizing: border-box;\n      color: ", ";\n      display: block;\n      font-size: 13px;\n      min-height: 36px;\n      line-height: 20.8px;\n      max-width: 220px;\n      opacity: 0.9;\n      padding: ", "px;\n      pointer-events: none;\n      position: fixed;\n      text-align: left;\n      transition-delay: 0s;\n      transition-duration: 0.3s;\n      transition-property: opacity;\n      transition-timing-function: ease-out;\n      visibility: hidden;\n      white-space: normal;\n      z-index: 3000;\n      \n      &::after,\n      &::before {\n        content: \"\";\n        width: 0;\n        height: 0;\n        position: absolute;\n      }\n      \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var TOOLTIP_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right'
};
var StyledSmartTooltip = styled.div(_templateObject(), borderRadius, white, spacing * 2, function (props) {
  return props.position === TOOLTIP_POSITION.TOP && css(_templateObject2());
}, function (props) {
  return props.position === TOOLTIP_POSITION.BOTTOM && css(_templateObject3());
}, function (props) {
  return props.position === TOOLTIP_POSITION.LEFT && css(_templateObject4());
}, function (props) {
  return props.position === TOOLTIP_POSITION.RIGHT && css(_templateObject5());
});

var _GET_POSITION_BY_PROP, _HAS_ENOUGH_SPACE_BY_;
var positionValues = Object.values(TOOLTIP_POSITION);
var containerDomNode = document.createElement('div');
var arrowMarginValue = 6;

var isString = function isString(value) {
  return Object.prototype.toString.call(value).slice(8, -1) === 'String';
};

function getElementCoords(target) {
  var coords = target.getBoundingClientRect();
  return {
    width: coords.width,
    height: coords.height,
    top: coords.top,
    bottom: coords.bottom,
    left: coords.left,
    right: coords.right
  };
}

function calculateTopPosition(targetCoords, smartTooltipCoords) {
  var halfOfTargetWidth = (targetCoords.right - targetCoords.left) / 2;
  var halfOfTooltipWidth = smartTooltipCoords.width / 2;
  var left = targetCoords.left + halfOfTargetWidth - halfOfTooltipWidth - window.pageXOffset;
  var top = targetCoords.top - (smartTooltipCoords.height + arrowMarginValue);
  return {
    top: "".concat(top, "px"),
    left: "".concat(left, "px"),
    visibility: 'visible',
    place: TOOLTIP_POSITION.TOP
  };
}

function calculateBottomPosition(targetCoords, smartTooltipCoords) {
  var halfOfTargetWidth = (targetCoords.right - targetCoords.left) / 2;
  var halfOfTooltipWidth = smartTooltipCoords.width / 2;
  var left = targetCoords.left + halfOfTargetWidth - halfOfTooltipWidth - window.pageXOffset;
  var top = targetCoords.bottom + arrowMarginValue;
  return {
    top: "".concat(top, "px"),
    left: "".concat(left, "px"),
    visibility: 'visible',
    place: TOOLTIP_POSITION.BOTTOM
  };
}

function calculateLeftPosition(targetCoords, smartTooltipCoords) {
  var top = targetCoords.height / 2 + targetCoords.top - smartTooltipCoords.height / 2;
  var left = targetCoords.left - smartTooltipCoords.width - arrowMarginValue;
  return {
    top: "".concat(top, "px"),
    left: "".concat(left, "px"),
    visibility: 'visible',
    place: TOOLTIP_POSITION.LEFT
  };
}

function calculateRightPosition(targetCoords, smartTooltipCoords) {
  var top = targetCoords.height / 2 + targetCoords.top - smartTooltipCoords.height / 2;
  var left = targetCoords.right + arrowMarginValue;
  return {
    top: "".concat(top, "px"),
    left: "".concat(left, "px"),
    visibility: 'visible',
    place: TOOLTIP_POSITION.RIGHT
  };
}

var GET_POSITION_BY_PROP = (_GET_POSITION_BY_PROP = {}, _defineProperty(_GET_POSITION_BY_PROP, TOOLTIP_POSITION.TOP, calculateTopPosition), _defineProperty(_GET_POSITION_BY_PROP, TOOLTIP_POSITION.BOTTOM, calculateBottomPosition), _defineProperty(_GET_POSITION_BY_PROP, TOOLTIP_POSITION.LEFT, calculateLeftPosition), _defineProperty(_GET_POSITION_BY_PROP, TOOLTIP_POSITION.RIGHT, calculateRightPosition), _GET_POSITION_BY_PROP);

function hasEnoughLeftAndRightSpace(targetCoords, smartTooltipCoords) {
  var halfOfTargetWidth = (targetCoords.right - targetCoords.left) / 2;
  var leftSpace = targetCoords.left + halfOfTargetWidth - window.pageXOffset;
  var rightSpace = window.innerWidth - targetCoords.right + halfOfTargetWidth;
  var hasLeftSpace = leftSpace >= smartTooltipCoords.width / 2;
  var hasRightSpace = rightSpace >= smartTooltipCoords.width / 2;
  return hasLeftSpace && hasRightSpace;
}

function hasEnoughTopSpace(targetCoords, smartTooltipCoords) {
  var hasTopSpace = smartTooltipCoords.height + arrowMarginValue <= targetCoords.top;
  return hasTopSpace && hasEnoughLeftAndRightSpace(targetCoords, smartTooltipCoords);
}

function hasEnoughBottomSpace(targetCoords, smartTooltipCoords) {
  var hasBottomSpace = smartTooltipCoords.height + arrowMarginValue <= window.innerHeight - targetCoords.bottom;
  return hasBottomSpace && hasEnoughLeftAndRightSpace(targetCoords, smartTooltipCoords);
}

function hasEnoughTopAndBottomSpace(targetCoords, smartTooltipCoords) {
  var halfOfTargetHeight = targetCoords.height / 2;
  var halfOfTooltipHeight = smartTooltipCoords.height / 2;
  var hasTopSpace = targetCoords.top + halfOfTargetHeight >= halfOfTooltipHeight;
  var hasBottomSpace = window.innerHeight - (targetCoords.bottom - halfOfTargetHeight) >= halfOfTooltipHeight;
  return hasTopSpace && hasBottomSpace;
}

function hasEnoughLeftSpace(targetCoords, smartTooltipCoords) {
  var hasLeftSpace = smartTooltipCoords.width + arrowMarginValue <= targetCoords.left - window.pageXOffset;
  return hasLeftSpace && hasEnoughTopAndBottomSpace(targetCoords, smartTooltipCoords);
}

function hasEnoughRightSpace(targetCoords, smartTooltipCoords) {
  var hasRightSpace = smartTooltipCoords.width + arrowMarginValue <= window.innerWidth - targetCoords.right;
  return hasRightSpace && hasEnoughTopAndBottomSpace(targetCoords, smartTooltipCoords);
}

var HAS_ENOUGH_SPACE_BY_POSITION = (_HAS_ENOUGH_SPACE_BY_ = {}, _defineProperty(_HAS_ENOUGH_SPACE_BY_, TOOLTIP_POSITION.TOP, hasEnoughTopSpace), _defineProperty(_HAS_ENOUGH_SPACE_BY_, TOOLTIP_POSITION.BOTTOM, hasEnoughBottomSpace), _defineProperty(_HAS_ENOUGH_SPACE_BY_, TOOLTIP_POSITION.LEFT, hasEnoughLeftSpace), _defineProperty(_HAS_ENOUGH_SPACE_BY_, TOOLTIP_POSITION.RIGHT, hasEnoughRightSpace), _HAS_ENOUGH_SPACE_BY_);

function calculatePosition(targetCoords, smartTooltipCoords, position) {
  if (position && positionValues.includes(position)) {
    return GET_POSITION_BY_PROP[position](targetCoords, smartTooltipCoords);
  }

  var possiblePositions = positionValues.filter(function (place) {
    return HAS_ENOUGH_SPACE_BY_POSITION[place](targetCoords, smartTooltipCoords);
  });

  if (possiblePositions && possiblePositions.length > 0) {
    return GET_POSITION_BY_PROP[possiblePositions[0]](targetCoords, smartTooltipCoords);
  }

  return calculateTopPosition(targetCoords, smartTooltipCoords);
}

function showTooltip(target, tip, position) {
  document.body.appendChild(containerDomNode);
  var container = /*#__PURE__*/React.createElement(SmartTooltip, {
    tip: tip,
    position: position,
    targetCoords: getElementCoords(target)
  });
  ReactDOM.render(container, containerDomNode);
}

function hideTooltip() {
  ReactDOM.unmountComponentAtNode(containerDomNode);

  if (_toConsumableArray(document.body.children).find(function (child) {
    return child === containerDomNode;
  })) {
    document.body.removeChild(containerDomNode);
  }
}

function SmartTooltip(_ref) {
  var tip = _ref.tip,
      targetCoords = _ref.targetCoords,
      position = _ref.position;
  var smartTooltip = useRef(null);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      style = _useState2[0],
      changeStyle = _useState2[1];

  var _useState3 = useState(position),
      _useState4 = _slicedToArray(_useState3, 2),
      tooltipPosition = _useState4[0],
      changePosition = _useState4[1];

  useEffect(function () {
    if (smartTooltip && smartTooltip.current) {
      var smartTooltipCoords = getElementCoords(smartTooltip.current);

      var _calculatePosition = calculatePosition(targetCoords, smartTooltipCoords, position),
          place = _calculatePosition.place,
          styles = _objectWithoutProperties(_calculatePosition, ["place"]);

      changeStyle(styles);
      changePosition(place);
    }
  }, [tip]);

  if (!tip) {
    return null;
  }

  return /*#__PURE__*/React.createElement(StyledSmartTooltip, {
    ref: smartTooltip,
    style: style,
    id: "smart-tooltip",
    position: tooltipPosition
  }, isString(tip) ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: tip
    }
  }) : tip);
}

SmartTooltip.propTypes = {
  tip: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  targetCoords: PropTypes.shape({
    width: PropTypes.number,
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number
  }),
  position: PropTypes.oneOf(positionValues)
};
SmartTooltip.defaultProps = {
  tip: undefined,
  targetCoords: {},
  position: undefined
};

export { TOOLTIP_POSITION, hideTooltip, showTooltip };
